import ThemedComponent from '../../hoc/ThemedComponent';
import OffersPage from './OffersPage/View';
import OfferPage from './OfferPage/View';
import { default as OffersPage3 } from '../../themes/3/pages/offers/OffersPage';
import { default as OffersPage4 } from '../../themes/4/pages/offers/OffersPage';
import { default as OfferPage3 } from '../../themes/3/pages/offers/OfferPage';
import { default as OfferPage4 } from '../../themes/4/pages/offers/OfferPage';

const ThemedOffersPages = {
  default: OffersPage,
  // 3: OffersPage3,
  // 4: OffersPage4,
};

const ThemedOfferPages = {
  default: OfferPage,
  // 3: OfferPage3,
  // 4: OfferPage4,
};

export const ThemedOffersPage = ThemedComponent(ThemedOffersPages);

export const OfferPageView = ThemedComponent(ThemedOfferPages);
